namespace GeniuzPOS.Purchase {
    export class PoInvoiceReceiveAppDtColumns {
        static columnsKey = 'Purchase.PoInvoiceReceiveAppDt';
    }
}
